module.exports = __webpack_public_path__ + "static/area.77a7ede8.jpg";